import { BaseApi } from "@/api/base";
import type { BillingReport } from "@/api/billing/dto/billing";
import type { Response } from "@/api/client";

export class BillingApi extends BaseApi {
  sendBillingReport(report: BillingReport, params = ""): Promise<Response<string>> {
    return this.client.get("/billing/reports" + `/${report}` + `?${params}`);
  }
}
